import { buildUrl } from '~/lib/net';


export class PayCodes {
  static getPayCodeById = (payCodeId) => `/v1/pay/codes/${payCodeId}`;
  static createPaycodeAttemp = () => '/v1/pay/codes';
  static getPayCodes = (offset, limit) => {
    const opts = {
      offset,
      limit,
    };
    return buildUrl('/v1/pay/codes', opts);
  };
}
